// extracted by mini-css-extract-plugin
module.exports = {"dosageContainer":"styles_dosageContainer__1-nep","dosage":"styles_dosage__2GMO5","hospital":"styles_hospital__3qkKf"};